export function secondsToFormattedHourMinutes(seconds: number, { formatting = 'short' }: { formatting?: 'short' | 'medium' | 'long' } = {}): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    let result = '';
    const hourFormatted = formatting === 'short' ? 'h' : formatting === 'medium' ? 'hr' : 'hours';
    const minuteFormatted = formatting === 'short' ? 'm' : formatting === 'medium' ? 'min' : 'minutes';
    if (hours > 0) result += `${hours} ${hourFormatted} `;
    if (minutes > 0 || hours === 0) result += `${minutes} ${minuteFormatted}`;
    return result.trim();
}

export function getTimestampFromUUIDv7(uuid: string): number {
    const hex = uuid.replace(/-/g, '').substring(0, 12);
    return parseInt(hex, 16);
}

export function getDateFromUUIDv7(uuid: string, includeMilliseconds = true): string {
    const hex = uuid.replace(/-/g, '').substring(0, 12);
    const ms = parseInt(hex, 16);
    const iso = new Date(ms).toISOString();
    return includeMilliseconds ? iso : iso.replace(/\.\d{3}Z$/, 'Z');
}

// rounds down the number and adds a "+" sign
export function formatDownNumber(num: number): string {
    let roundedNumber = num;
    if (num >= 1000) {
        roundedNumber = Math.floor(num / 100) * 100;
    } else if (num >= 100) {
        roundedNumber = Math.floor(num / 10) * 10;
    } else if (num >= 10) {
        roundedNumber = Math.floor(num / 10) * 10;
    }
    return `${new Intl.NumberFormat('en-GB').format(roundedNumber)}+`;
}